import React from 'react'

export default function IconFourCol({ colour = 'currentColor', ...rest }) {
    return (
        <svg
            preserveAspectRatio='none'
            width='264'
            height='24'
            viewBox='0 0 264 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...rest}
        >
            <path
                d='M12 0.5H60C61.933 0.5 63.5 2.067 63.5 4V20C63.5 21.933 61.933 23.5 60 23.5H12C10.067 23.5 8.5 21.933 8.5 20V4C8.5 2.067 10.067 0.5 12 0.5Z'
                fill='#EEEEED'
            />
            <path
                d='M12 0.5H60C61.933 0.5 63.5 2.067 63.5 4V20C63.5 21.933 61.933 23.5 60 23.5H12C10.067 23.5 8.5 21.933 8.5 20V4C8.5 2.067 10.067 0.5 12 0.5Z'
                stroke='#E1E1E0'
            />
            <path
                d='M76 0.5H124C125.933 0.5 127.5 2.067 127.5 4V20C127.5 21.933 125.933 23.5 124 23.5H76C74.067 23.5 72.5 21.933 72.5 20V4C72.5 2.067 74.067 0.5 76 0.5Z'
                fill='#EEEEED'
            />
            <path
                d='M76 0.5H124C125.933 0.5 127.5 2.067 127.5 4V20C127.5 21.933 125.933 23.5 124 23.5H76C74.067 23.5 72.5 21.933 72.5 20V4C72.5 2.067 74.067 0.5 76 0.5Z'
                stroke='#E1E1E0'
            />
            <path
                d='M140 0.5H188C189.933 0.5 191.5 2.067 191.5 4V20C191.5 21.933 189.933 23.5 188 23.5H140C138.067 23.5 136.5 21.933 136.5 20V4C136.5 2.067 138.067 0.5 140 0.5Z'
                fill='#EEEEED'
            />
            <path
                d='M140 0.5H188C189.933 0.5 191.5 2.067 191.5 4V20C191.5 21.933 189.933 23.5 188 23.5H140C138.067 23.5 136.5 21.933 136.5 20V4C136.5 2.067 138.067 0.5 140 0.5Z'
                stroke='#E1E1E0'
            />
            <path
                d='M204 0.5H252C253.933 0.5 255.5 2.067 255.5 4V20C255.5 21.933 253.933 23.5 252 23.5H204C202.067 23.5 200.5 21.933 200.5 20V4C200.5 2.067 202.067 0.5 204 0.5Z'
                fill='#EEEEED'
            />
            <path
                d='M204 0.5H252C253.933 0.5 255.5 2.067 255.5 4V20C255.5 21.933 253.933 23.5 252 23.5H204C202.067 23.5 200.5 21.933 200.5 20V4C200.5 2.067 202.067 0.5 204 0.5Z'
                stroke='#E1E1E0'
            />
        </svg>
    )
}
